import { writable } from 'svelte/store'
import api from '../../app/api'
import uuidv4 from 'uuid/v4'
import { navigate } from "svelte-routing";
import {documentTypes} from "./document-types";

const uuid = uuidv4()

function uploadFilesStore() {
    const isReading = writable(false)
    const recognitionResult = writable({})
    const uploadedFiles = writable({})

    function checkFile(file, type) {
        uploadedFiles.update((files) => ({
            ...files,
            [type]: {
                id: uuidv4(),
                file,
                type,
                isUploading: true,
                isValid: false,
                error: ''
            }
        }))

        let formData = new FormData()
        formData.append('document', file)

        api.checkDocument({
            data: formData,
            type,
            uuid
        })
        .then(
            result => {
                console.log('result', result)
                if (result.data.documentPresent) {
                    uploadedFiles.update((files) => {
                        files[type] = {
                            ...files[type],
                            isUploading: false,
                            isValid: true
                        }
                        return {...files}
                    })
                } else {
                    uploadedFiles.update((files) => {
                        files[type] = {
                            ...files[type],
                            isUploading: false,
                            isValid: false,
                            error: 'Wrong document type'
                        }
                        return {...files}
                    })
                }
            },
            error => {
                uploadedFiles.update((files) => {
                    files[type] = {
                        ...files[type],
                        isUploading: false,
                        isValid: false,
                        error: error.data.error
                    }
                    return {...files}
                })
            }
        )
    }

    function getResultSynchronous() {
        isReading.set(true)
        api.getResultSynchronous(uuid).then(
            result => {
                isReading.set(false)
                recognitionResult.update(() => result.data)
                navigate('/results')
            },
            () => {
                isReading.set(false)
            }
        )
    }

    function remove(id) {
        uploadedFiles.update(files => {
            console.log(files)
            Object.entries(files).map(file => {
                if (file[1].id === id) {
                    delete files[file[0]]
                }
            })
            return files
        })
    }

    function clean() {
        recognitionResult.set({})
        uploadedFiles.set({})
    }

    return {
        isReading,
        recognitionResult,
        subscribe: uploadedFiles.subscribe,
        checkFile,
        getResultSynchronous,
        remove,
        clean
    }
}

export default uploadFilesStore()

